import React from 'react';
import ContractOpenBillsList from './ContractOpenBillsList';
import { observer } from 'mobx-react';
import ContractOpenBillsService from '../services/ContractOpenBillsService';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';

class ContractOpenBillsContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string.isRequired,
  };

  contractOpenBillsService = new ContractOpenBillsService();

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.contractId !== this.props.contractId) {
      this.contractOpenBillsService.load(this.props.contractId);
    }
  }

  render() {
    return <ContractOpenBillsList bills={toJS(this.contractOpenBillsService.bills)} />;
  }
}

export default observer(ContractOpenBillsContainer);
